<div class="forum-card-grid">
  <div class="forum-card" *ngFor="let post of posts">
    <div (click)="openForum(post.topicSlug)" class="clickable-card">
      <div class="p-4 surface-card border-round shadow-2 h-full flex flex-column justify-between">
        <div>
        
          <!-- Header -->
          <div class="flex align-items-center mb-3">
         

              <img class="w-4rem h-4rem border-circle mr-3"
                   [src]="post.avatarSrc"
                   alt="Avatar"
                   (error)="onImageError(post)"
                   loading="lazy"/>
        

      


            <div>
              <div class="font-bold text-lg text-900">{{ post.topicName }}</div>
              <div class="text-sm text-color-secondary">{{ post.timeAgo }}</div>
            </div>
          </div>

          <!-- Topic -->
          <div class="text-sm text-color-secondary mb-2">
            <strong>Name & Company:</strong>   {{ post.name }}
          </div>

          <!-- Comment -->
          <div class="text-sm text-color-secondary mb-2">
            <strong>Comment:</strong> {{ post.postContent }}
          </div>

          <!-- Tags -->
          <div class="mb-3">
            <div class="flex flex-wrap gap-2">
              <span *ngFor="let tag of post.tags"
                    class="text-xs bg-blue-100 text-blue-700 px-2 py-1 border-round">
                {{ tag.tagName }}
              </span>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="flex justify-content-between text-sm text-color-secondary pt-2 border-top-1 surface-border mt-auto">
          <div><i class="pi pi-calendar mr-1"></i>{{ post.lastPostDate | date }}</div>
          <div>
            <i class="pi pi-comments mr-1"></i>{{ post.comments }} comment{{ post.comments === 1 ? '' : 's' }}
          </div>
          <div><i class="pi pi-eye mr-1"></i>{{ post.views }} view{{ post.views === 1 ? '' : 's' }}</div>
        </div>
      </div>

    </div>

  </div>
</div>
